import React, { useState } from 'react';
import Card from '../ui/Card';
import { TrophyIcon } from 'lucide-react';
import { DashboardFilters } from '../../pages/Dashboard';
const baseMerchants = [{
  id: 'M-10042',
  name: 'Daraz.pk',
  region: 'Karachi',
  baseTxns: 12450,
  baseValue: 45.2,
  avgTicket: 3630,
  success: 99.2
}, {
  id: 'M-10893',
  name: 'FoodPanda',
  region: 'Karachi',
  baseTxns: 9820,
  baseValue: 12.8,
  avgTicket: 1303,
  success: 98.5
}, {
  id: 'M-20411',
  name: 'Imtiaz Super Market',
  region: 'Karachi',
  baseTxns: 8400,
  baseValue: 58.4,
  avgTicket: 6952,
  success: 99.8
}, {
  id: 'M-30122',
  name: 'Metro Cash & Carry',
  region: 'Lahore',
  baseTxns: 7100,
  baseValue: 62.1,
  avgTicket: 8746,
  success: 99.5
}, {
  id: 'M-10554',
  name: 'Khaadi',
  region: 'Multiple',
  baseTxns: 5200,
  baseValue: 31.2,
  avgTicket: 6000,
  success: 99.1
}, {
  id: 'M-40881',
  name: 'Careem',
  region: 'Multiple',
  baseTxns: 4800,
  baseValue: 4.3,
  avgTicket: 895,
  success: 97.8
}, {
  id: 'M-20993',
  name: 'Al-Fatah',
  region: 'Lahore',
  baseTxns: 4100,
  baseValue: 38.5,
  avgTicket: 9390,
  success: 99.6
}, {
  id: 'M-50112',
  name: 'Sana Safinaz',
  region: 'Multiple',
  baseTxns: 3800,
  baseValue: 24.7,
  avgTicket: 6500,
  success: 98.9
}, {
  id: 'M-10223',
  name: 'Airlift',
  region: 'Karachi',
  baseTxns: 3200,
  baseValue: 2.1,
  avgTicket: 656,
  success: 96.5
}, {
  id: 'M-60334',
  name: 'J.',
  region: 'Multiple',
  baseTxns: 2900,
  baseValue: 18.8,
  avgTicket: 6482,
  success: 99.0
}];
const timeMultipliers = {
  Today: 1,
  Week: 7,
  MTD: 22,
  YTD: 265
};
const schemeMultipliers: Record<string, number> = {
  'All Schemes': 1,
  Visa: 0.35,
  MasterCard: 0.28,
  PayPak: 0.2,
  UnionPay: 0.1,
  RAAST: 0.07
};
const channelMultipliers: Record<string, number> = {
  'All Channels': 1,
  POS: 0.45,
  'E-commerce': 0.35,
  'RAAST QR': 0.2
};
interface TopMerchantsProps {
  filters: DashboardFilters;
}
export const TopMerchants: React.FC<TopMerchantsProps> = ({
  filters
}) => {
  const [sortBy, setSortBy] = useState<'volume' | 'value'>('volume');
  const {
    timeRange,
    scheme,
    channel
  } = filters;
  const timeMult = timeMultipliers[timeRange];
  const schemeMult = schemeMultipliers[scheme];
  const channelMult = channelMultipliers[channel];
  const totalMult = timeMult * schemeMult * channelMult;
  const merchants = baseMerchants.map(m => ({
    id: m.id,
    name: m.name,
    region: m.region,
    txns: Math.round(m.baseTxns * totalMult),
    value: m.baseValue * totalMult,
    avgTicket: `PKR ${Math.round(m.avgTicket * (0.95 + channelMult * 0.1)).toLocaleString()}`,
    success: m.success
  }));
  const sortedMerchants = [...merchants].sort((a, b) => {
    if (sortBy === 'volume') return b.txns - a.txns;
    return b.value - a.value;
  });
  const getRankIcon = (index: number) => {
    if (index === 0) return <div className="w-8 h-8 rounded-full bg-yellow-100 dark:bg-yellow-900/40 flex items-center justify-center" data-id="element-254">
          <TrophyIcon className="h-4 w-4 text-yellow-600 dark:text-yellow-500" data-id="element-255" />
        </div>;
    if (index === 1) return <div className="w-8 h-8 rounded-full bg-slate-100 dark:bg-slate-800 flex items-center justify-center" data-id="element-256">
          <TrophyIcon className="h-4 w-4 text-slate-500 dark:text-slate-400" data-id="element-257" />
        </div>;
    if (index === 2) return <div className="w-8 h-8 rounded-full bg-amber-100 dark:bg-amber-900/40 flex items-center justify-center" data-id="element-258">
          <TrophyIcon className="h-4 w-4 text-amber-700 dark:text-amber-600" data-id="element-259" />
        </div>;
    return <div className="w-8 h-8 rounded-full bg-slate-50 dark:bg-slate-800/50 flex items-center justify-center" data-id="element-260">
        <span className="text-xs font-bold text-slate-500" data-id="element-261">{index + 1}</span>
      </div>;
  };
  const formatValue = (value: number) => {
    if (value >= 1) return `PKR ${value.toFixed(1)}M`;
    return `PKR ${(value * 1000).toFixed(0)}K`;
  };
  return <Card data-id="element-262">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between mb-8" data-id="element-263">
        <h3 className="text-lg font-semibold text-slate-900 dark:text-white tracking-tight" data-id="element-264">
          Top Performing Merchants
        </h3>
        <div className="mt-4 sm:mt-0 flex p-1 bg-slate-100 dark:bg-slate-800/80 rounded-xl shadow-inner" data-id="element-265">
          <button onClick={() => setSortBy('volume')} className={`px-5 py-2 text-xs font-bold rounded-lg transition-all ${sortBy === 'volume' ? 'bg-white dark:bg-slate-700 text-accent-600 dark:text-accent-400 shadow-sm ring-1 ring-slate-200/50 dark:ring-slate-600' : 'text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-200'}`} data-id="element-266">
            By Volume
          </button>
          <button onClick={() => setSortBy('value')} className={`px-5 py-2 text-xs font-bold rounded-lg transition-all ${sortBy === 'value' ? 'bg-white dark:bg-slate-700 text-accent-600 dark:text-accent-400 shadow-sm ring-1 ring-slate-200/50 dark:ring-slate-600' : 'text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-200'}`} data-id="element-267">
            By Value
          </button>
        </div>
      </div>

      <div className="overflow-x-auto rounded-xl border border-slate-200 dark:border-slate-700 shadow-sm" data-id="element-268">
        <table className="min-w-full divide-y divide-slate-200 dark:divide-slate-700" data-id="element-269">
          <thead className="bg-slate-50 dark:bg-slate-800/80" data-id="element-270">
            <tr data-id="element-271">
              <th scope="col" className="px-5 py-4 text-center text-xs font-bold text-slate-500 dark:text-slate-400 uppercase tracking-wider w-16" data-id="element-272">
                Rank
              </th>
              <th scope="col" className="px-5 py-4 text-left text-xs font-bold text-slate-500 dark:text-slate-400 uppercase tracking-wider" data-id="element-273">
                Merchant
              </th>
              <th scope="col" className="px-5 py-4 text-left text-xs font-bold text-slate-500 dark:text-slate-400 uppercase tracking-wider" data-id="element-274">
                Region
              </th>
              <th scope="col" className="px-5 py-4 text-right text-xs font-bold text-slate-500 dark:text-slate-400 uppercase tracking-wider" data-id="element-275">
                Transactions
              </th>
              <th scope="col" className="px-5 py-4 text-right text-xs font-bold text-slate-500 dark:text-slate-400 uppercase tracking-wider" data-id="element-276">
                Total Value
              </th>
              <th scope="col" className="px-5 py-4 text-right text-xs font-bold text-slate-500 dark:text-slate-400 uppercase tracking-wider" data-id="element-277">
                Avg Ticket
              </th>
              <th scope="col" className="px-5 py-4 text-right text-xs font-bold text-slate-500 dark:text-slate-400 uppercase tracking-wider" data-id="element-278">
                Success
              </th>
            </tr>
          </thead>
          <tbody className="bg-white dark:bg-slate-800 divide-y divide-slate-100 dark:divide-slate-700/50" data-id="element-279">
            {sortedMerchants.map((merchant, index) => <tr key={merchant.id} className="hover:bg-slate-50 dark:hover:bg-slate-700/30 transition-colors" data-id="element-280">
                <td className="px-5 py-3 whitespace-nowrap text-center" data-id="element-281">
                  <div className="flex justify-center" data-id="element-282">
                    {getRankIcon(index)}
                  </div>
                </td>
                <td className="px-5 py-3 whitespace-nowrap" data-id="element-283">
                  <div className="text-sm font-bold text-slate-900 dark:text-white" data-id="element-284">
                    {merchant.name}
                  </div>
                  <div className="text-xs font-medium text-slate-500 dark:text-slate-400 mt-0.5" data-id="element-285">
                    {merchant.id}
                  </div>
                </td>
                <td className="px-5 py-3 whitespace-nowrap text-sm font-medium text-slate-600 dark:text-slate-400" data-id="element-286">
                  {merchant.region}
                </td>
                <td className="px-5 py-3 whitespace-nowrap text-sm text-slate-900 dark:text-white text-right font-bold" data-id="element-287">
                  {merchant.txns.toLocaleString()}
                </td>
                <td className="px-5 py-3 whitespace-nowrap text-sm text-accent-600 dark:text-accent-400 text-right font-bold" data-id="element-288">
                  {formatValue(merchant.value)}
                </td>
                <td className="px-5 py-3 whitespace-nowrap text-sm font-medium text-slate-600 dark:text-slate-400 text-right" data-id="element-289">
                  {merchant.avgTicket}
                </td>
                <td className="px-5 py-3 whitespace-nowrap text-right" data-id="element-290">
                  <span className={`inline-flex items-center px-2.5 py-1 rounded-md text-xs font-bold ${merchant.success >= 99 ? 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-400' : merchant.success >= 98 ? 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-400' : 'bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-400'}`} data-id="element-291">
                    {merchant.success}%
                  </span>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </Card>;
};